import React, { useState, useEffect } from 'react';
import profileImage from './Assets/Me.jpeg';

function App() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [formStatus, setFormStatus] = useState('');
  const [activeSection, setActiveSection] = useState('home');
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);

   
    const handleScroll = () => {
      const sections = ['home', 'about', 'skills', 'experience', 'projects', 'services', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  const skills = [
    { name: 'React.js', level: 70, category: 'Frontend' },
    { name: 'Node.js', level: 70, category: 'Backend' },
    { name: 'MongoDB', level: 50, category: 'Database' },
    { name: 'Express.js', level: 50, category: 'Backend' },
    { name: 'JavaScript', level: 50, category: 'Language' },
    { name: 'Python', level: 15, category: 'Language' },
    { name: 'CSS/Sass', level: 80, category: 'Frontend' },
    { name: 'Git & GitHub', level: 50, category: 'Tools' }
  ];

  const projects = [
    {
      title: 'Knowledge Hub',
      description: 'A app In which you can find any book just by writing Its name, and soon In Sha Allah I will add podcasts, articles etc In this..',
      technologies: ['React', 'Node.js', 'MongoDB', 'Express'],
      image: '/api/placeholder/400/250',
      github: 'https://github.com/AhmadMurtaza1372',
      live: '#',
      category: 'MERN Stack'
    },
   
    {
      title: 'My Portfolio',
      description: 'You are right now exploring this one.',
      technologies: ['React', 'Node.js'],
      image: '/api/placeholder/400/250',
      github: 'https://github.com/AhmadMurtaza1372',
      live: '#',
      category: 'Frontend and little bit Backend'
    },
   
  ];

  const experience = [
    {
      title: 'Doing Btech CSE',
      Place: 'IUST Kashmir',
      period: '2025/Present',
      description: ''
    },
     {
      title: 'Learned Mern Stack ',
      Place: 'ILS Srinagar',
      period: '2024',
      description: 'I Specifically mentioned this from my DIploma Journey.'
    },

    {
      title: 'Done Diploma in Software Engineering(DISE)',
      Place: 'ILS Srinagar',
      period: '2023/24 ',
      description: 'It was a nice journey'
    },
   


  ];

  const services = [
    {
      title: 'Web Development',
      description: 'Full-stack web applications using modern technologies like MERN stack.',
      icon: '🌐'
    },
    {
      title: 'Mobile Development',
      description: 'Cross-platform mobile applications using React Native.',
      icon: '📱'
    },
    {
      title: 'UI/UX Design',
      description: 'Modern, responsive designs that provide excellent user experience.',
      icon: '🎨'
    },
   
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
   
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus('Please fill in all fields.');
      return;
    }
    
    setFormStatus('Sending message...');
    
    try {
     
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
       
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setFormStatus('Thank you for your message! Email sent successfully.');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setFormStatus('Failed to send email: ' + (data.message || data.error));
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setFormStatus('Error sending email. Is the server running?');
    }
  };
  return (
    <div className={`app ${isLoaded ? 'loaded' : ''}`}>
     
      <nav className="sidebar">
        <div className="logo">
          <h3>AMK</h3>
          <span>Portfolio</span>
        </div>
        <ul className="nav-menu">
          <li className={activeSection === 'home' ? 'active' : ''}>
            <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>
              <span className="icon">🏠</span>
              <span>Home</span>
            </a>
          </li>
          <li className={activeSection === 'about' ? 'active' : ''}>
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>
              <span className="icon">👨‍💻</span>
              <span>About</span>
            </a>
          </li>
          <li className={activeSection === 'skills' ? 'active' : ''}>
            <a href="#skills" onClick={(e) => { e.preventDefault(); scrollToSection('skills'); }}>
              <span className="icon">⚡</span>
              <span>Skills</span>
            </a>
          </li>
          <li className={activeSection === 'experience' ? 'active' : ''}>
            <a href="#experience" onClick={(e) => { e.preventDefault(); scrollToSection('experience'); }}>
              <span className="icon">💼</span>
              <span>Experience</span>
            </a>
          </li>
          <li className={activeSection === 'projects' ? 'active' : ''}>
            <a href="#projects" onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}>
              <span className="icon">🚀</span>
              <span>Projects</span>
            </a>
          </li>
          <li className={activeSection === 'services' ? 'active' : ''}>
            <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
              <span className="icon">🛠️</span>
              <span>Services</span>
            </a>
          </li>
          <li className={activeSection === 'contact' ? 'active' : ''}>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>
              <span className="icon">📧</span>
              <span>Contact</span>
            </a>
          </li>
        </ul>
      </nav>

      
      <main className="main-content">
       
        <section id="home" className="hero-section">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                <span className="greeting">Hello, I'm</span>
                <span className="name">Ahmad Murtaza</span>
                <span className="role">Developer</span>
              </h1>
              <p className="hero-description">
                Passionate about creating exceptional digital experiences through clean code and innovative solutions. 
                Specialized in MERN stack development with a focus on modern web technologies.
              </p>
              <div className="hero-buttons">
                <button className="btn-primary" onClick={() => scrollToSection('projects')}>
                  View My Work
                </button>
                <button className="btn-secondary" onClick={() => scrollToSection('contact')}>
                  Get In Touch
                </button>
              </div>
              <div className="hero-stats">
                <div className="stat">
                  <span className="stat-number">2+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="stat">
                  <span className="stat-number">2+</span>
                  <span className="stat-label">Projects Completed</span>
                </div>
                <div className="stat">
                  <span className="stat-number">1+</span>
                  <span className="stat-label">Happy Client</span>
                </div>
              </div>
            </div>
            <div className="hero-image">
              <div className="image-container">
                <img src={profileImage} alt="Ahmad Murtaza" />
                <div className="image-overlay">
                  <div className="tech-badge">React</div>
                  <div className="tech-badge">Node.js</div>
                  <div className="tech-badge">MongoDB</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        
        <section id="about" className="about-section">
          <div className="section-header">
            <h2>About Me</h2>
            <p>Get to know more about my journey and expertise</p>
          </div>
          <div className="about-content">
            <div className="about-text">
              <div className="about-card">
                <h3>🎯 My Mission</h3>
                <p>
                  I’m passionate about creating impactful digital solutions that solve real-world problems. I believe in writing clean, maintainable code and staying up-to-date with the latest technologies to deliver exceptional user experiences.
                </p>
              </div>
              <div className="about-card">
                <h3>🚀 What I Do</h3>
                <p>
                I build web applications ranging from responsive user interfaces to robust backend systems. My experience includes frontend frameworks, backend development, database design, and cloud deployment.
                </p>
              </div>
              <div className="about-card">
                <h3>💡 My Approach</h3>
                <p>
                  I follow agile development practices and believe in continuous learning. Every project is an 
                  opportunity to implement best practices, optimize performance, and create scalable solutions 
                  that can grow with business needs.
                </p>
              </div>
            </div>
            <div className="about-highlights">
              <div className="highlight-item">
                <div className="highlight-icon">🎓</div>
                <div className="highlight-content">
                  <h4>Education</h4>
                  <p>Doing Btech CSE</p>
                  <p>Done Diploma in CSE</p>
                  <span>Focused on Software Development & Systems Design</span>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">🏆</div>
                <div className="highlight-content">
                  <h4>Achievements</h4>
                  <p>3 Apps completed</p>
                  
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">🌟</div>
                <div className="highlight-content">
                  <h4>Interests</h4>
                  <p>AI/ML,Open Source</p>
                  <span>Always exploring new technologies</span>
                </div>
              </div>
            </div>
          </div>
        </section>

    
        <section id="skills" className="skills-section">
          <div className="section-header">
            <h2>Skills & Technologies</h2>
            <p>My technical expertise and proficiency levels</p>
          </div>
          <div className="skills-content">
            {['Frontend', 'Backend', 'Database', 'Language', 'Tools'].map(category => (
              <div key={category} className="skill-category">
                <h3>{category}</h3>
                <div className="skills-list">
                  {skills.filter(skill => skill.category === category).map((skill, index) => (
                    <div key={index} className="skill-item">
                      <div className="skill-info">
                        <span className="skill-name">{skill.name}</span>
                        <span className="skill-percentage">{skill.level}%</span>
                      </div>
                      <div className="skill-bar">
                        <div 
                          className="skill-progress" 
                          style={{ width: `${skill.level}%` }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        
        <section id="experience" className="experience-section">
          <div className="section-header">
            <h2>My Journey</h2>
            <p>My professional journey and achievements</p>
          </div>
          <div className="experience-timeline">
            {experience.map((exp, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  <div className="experience-card">
                    <div className="experience-header">
                      <h3>{exp.title}</h3>
                      <span className="period">{exp.period}</span>
                    </div>
                    <h4 className="company">{exp.company}</h4>
                    <p className="description">{exp.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

       
        <section id="projects" className="projects-section">
          <div className="section-header">
            <h2>Featured Projects</h2>
            <p>Some of my recent work and achievements</p>
          </div>
          <div className="projects-grid">
            {projects.map((project, index) => (
              <div key={index} className="project-card">
                <div className="project-image">
                  <div className="placeholder-image">
                    <span className="project-icon">💻</span>
                  </div>
                  <div className="project-overlay">
                    <a href={project.github} className="project-link" target="_blank" rel="noopener noreferrer">
                      <span>GitHub</span>
                    </a>
                    <a href={project.live} className="project-link">
                      <span>Live Demo</span>
                    </a>
                  </div>
                </div>
                <div className="project-content">
                  <div className="project-category">{project.category}</div>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-technologies">
                    {project.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        
        <section id="services" className="services-section">
          <div className="section-header">
            <h2>Services I Offer</h2>
            <p>Comprehensive solutions for your digital needs</p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-features">
                  <span>✓ Professional Quality</span>
                 
                </div>
              </div>
            ))}
          </div>
        </section>

        
        <section id="contact" className="contact-section">
          <div className="section-header">
            <h2>Get In Touch</h2>
            <p>Let's discuss your next project</p>
          </div>
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h4>Email</h4>
                  <p>ahmadmurtazakhan123@gmailcom</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📱</div>
                <div>
                  <h4>Phone</h4>
                  <p>+91987654321</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Location</h4>
                  <p>Kashmir</p>
                </div>
              </div>
              <div className="social-links">
                <a href="https://www.linkedin.com/in/ahmad-murtaza-khan-349107376/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <span>LinkedIn</span>
                </a>
                <a href="https://github.com/AhmadMurtaza1372" target="_blank" rel="noopener noreferrer" className="social-link">
                  <span>GitHub</span>
                </a>
                
              </div>
            </div>
            <div className="contact-form-container">
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your full name"
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="your.email@example.com"
                  />
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Tell me about your project..."
                    rows="5"
                  ></textarea>
                </div>
                <button type="submit" className="btn-primary full-width">
                  Send Message
                </button>
              </form>
              {formStatus && <div className="form-status">{formStatus}</div>}
            </div>
          </div>
        </section>

       
        <footer className="footer">
          <div className="footer-content">
            <p>© 2026 Ahmad Murtaza. All rights reserved.</p>
            <p>Built with MERN</p>
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;
